import { TapTableView } from "../components/orders/TapTableView";

export const TablePage = () => <TapTableView defaultMode="table" />;

export default TablePage;
